<template>
  <div class="body d-flex py-lg-3 py-md-2">
    <div class="container-xxl">
      <div class="row align-items-center">
        <div class="border-0 mb-2">
          <div class="card-header py-1 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between flex-wrap">
            <!-- Filter section with a more compact layout -->
            <div class="d-flex align-items-center gap-3 col-12 col-md-10">
              <!-- User filter -->
              <div class="col-12 col-md-2" v-if="superUser || canViewAll">
                <select2 v-model="filters.userId" :settings="userSettings" :options="userSelectOptions" placeholder="Χρήστες" multiple></select2>
              </div>

              <!-- Status filter -->
              <div class="col-12 col-md-2">
                <select2 v-model="filters.statusId" :settings="statusSettings" :options="statusOptions" placeholder="Status" multiple></select2>
              </div>

              <!-- Date from filter -->
              <div class="col-12 col-md-3">
                <div class="d-flex align-items-center">
                  <label for="filterDateFrom" class="form-label mb-0">Ημ/νία από:</label>
                  <input type="date" class="form-control ms-2" v-model="filters.dateFrom">
                </div>
              </div>
<!-- Date to filter -->
<div class="col-12 col-md-3">
                <div class="d-flex align-items-center">
                  <label for="filterDateTo" class="form-label mb-0">Ημ/νία έως:</label>
                  <input type="date" class="form-control ms-2" v-model="filters.dateTo">
                </div>
              </div>
              <!-- Only Active checkbox -->
              <div class="col-12 col-md-2 d-flex align-items-center" v-if="superUser || canViewAll">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="onlyActive"
                  v-model="filters.onlyActive"
                  @change="fetchData"
                />
                <label class="form-check-label ms-2" for="onlyActive">Only Active Users</label>
              </div>

              

              <!-- Search button -->
              <div class=" col-md-2 d-flex justify-content-start justify-content-md-end">
                <button type="button" class="btn btn-secondary" @click="fetchData">
                  <i class="icofont-search me-1 fs-6"></i>Search
                </button>
              </div>
            </div>

            <!-- Actions Button and Dropdown -->
            <div class="d-flex align-items-center gap-3 col-12 col-md-2 mt-3 mt-md-0">
              <button class="btn btn-secondary dropdown-menu-toggler" type="button" @click.stop="toggleActionsDropdown">
                Ενέργειες
              </button>
              <ul class="dropdown-menu border-0 shadow p-3" :class="{'show': showActionsDropdown}" v-show="showActionsDropdown" style="right:60px; top:170px">
                <li><a class="dropdown-item py-2 rounded archiveSelected" @click.prevent="exportWithoutTasks" style="cursor:pointer">Εξαγωγή χωρίς tasks</a></li>
                <li><a class="dropdown-item py-2 rounded archiveSelected" @click.prevent="exportWithTasks" style="cursor:pointer">Εξαγωγή με tasks</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Table for reports -->
      <div class="row clearfix g-3">
        <div class="col-lg-12">
          <div>
            <div class="card mb-3">
              <div class="card-body p-0 mt-3 table-responsive">
                <table id="reports" class="table table-hover align-middle mb-0 mis_table" style="width:100%">
                  <thead>
                    <tr class="reportsHeader">
                      <th style="width:10%; color:white">project</th>
                      <th style="width:10%; color:white">Εκτιμ.</th>
                      <th style="width:10%; color:white">Total</th>
                      <th style="width:10%; color:white">Period</th>
                      <!-- Render user columns only if onlyActive is false or the user is active -->
                      <th style="width:10%; color:white" v-for="user in filteredUsers" :key="user.userId">{{ user.username }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(report, index) in reports" :key="report.project_id">
  <!-- Summary row -->
  <tr @click="toggleTasks(report.project_id)">
    <td>
      <span v-if="index === 0">{{ report.title }}</span>
      <router-link v-else :to="getProjectLink(report.project_id)">
        {{ report.title }}
      </router-link>
    </td>
    <td>{{ report.estimated_hours }}</td>
    <td>{{ report.total_worked_hours_formatted }}</td>
    <td>{{ report.total_worked_hours_period_formatted }}</td>
    <td v-for="user in filteredUsers" :key="user.userId">
      {{ getUserProjectHours(report.user_hours, user.userId) }}
    </td>
  </tr>

  <!-- Task rows -->
  <tr
    v-if="report.tasks && report.show_tasks"
    v-for="task in report.tasks"
    :key="task.task_id"
    class="reports_tasks"
    style="font-weight: lighter;"
  >
    <td>
      <router-link :to="getTaskLink(task.task_id)">
        {{ task.title }}
      </router-link>
    </td>
    <td>-</td>
    <td>{{ task.total_worked_hours_formatted }}</td>
    <td>{{ task.total_worked_hours_period_formatted }}</td>
    <td v-for="user in filteredUsers" :key="user.userId">
      {{ getUserTaskHours(task.user_hours, user.userId) }}
    </td>
  </tr>
</template>

                    <tr v-if="!reports || !reports.length">
                      <td colspan="1">No data</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import apiClient from '@/services/api';
import axios from 'axios';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { RouterLink } from 'vue-router';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';

export default {
  components: {
    Select2,
    RouterLink
  },
  data() {
    return {
      filters: {
        dateFrom: null,
        dateTo: null,
        userId: [],
        statusId: [],
        onlyActive: false,
      },
      users: [],
      statuses: [],
      reports: [],
      showActionsDropdown: false,
    };
  },
  computed: {
    ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
    userSettings() {
      return { multiple: true, allowClear: true };
    },
    userSelectOptions() {
  // Use filteredUsers (which respects the "only active" checkbox)
  return this.filteredUsers.map(user => ({ id: user.userId, text: user.username }));
},
    filteredUsers() {
      if (this.filters.onlyActive) {
        // Filter users by active status if onlyActive is checked
        return this.users.filter(user => user.active === 1);
      }
      return this.users; // Return all users if onlyActive is not checked
    },
    userOptions() {
      return this.users.map(user => ({ id: user.userId, text: user.username }));
    },
    statusSettings() {
      return { multiple: true, allowClear: true };
    },
    statusOptions() {
      return this.statuses.map(status => ({ id: status.id, text: status.description }));
    },
    superUser() {
        return this.getSuperUserPermission === 1;
    },
     userPermissions() {
        return this.getUserPermission('Reporting');
    },
    
    canViewAll() {
        return this.userPermissions?.viewAdmin === 1;
    },
    
  },
  methods: {
    closeActionsDropdown(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showActionsDropdown = false;
      }
    },
    toggleActionsDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    getProjectLink(projectId) {
      let l = `project?id=${projectId}&activeTab=report`;
      if (this.filters.dateFrom) {
        l += `&date_from=${this.filters.dateFrom}`;
      }
      if (this.filters.dateTo) {
        l += `&date_to=${this.filters.dateTo}`;
      }
      if (this.filters.statusId.length) {
        for (let i = 0; i < this.filters.statusId.length; i++) {
          l += `&statusId[]=${this.filters.statusId[i]}`;
        }
      }
      return l;
    },
    getTaskLink(taskId) {
      let l = `task?id=${taskId}&activeTab=report`;
      // if (this.filters.dateFrom) {
      //   l += `&date_from=${this.filters.dateFrom}`;
      // }
      // if (this.filters.dateTo) {
      //   l += `&date_to=${this.filters.dateTo}`;
      // }
      // if (this.filters.statusId.length) {
      //   for (let i = 0; i < this.filters.statusId.length; i++) {
      //     l += `statusId[]=${this.filters.statusId[i]}`;
      //   }
      // }
      return l;
    },
    fetchData() {
  const { dateFrom, dateTo, userId, statusId, onlyActive } = this.filters;

  const params = {
    date_from: dateFrom,
    date_to: dateTo,
    userId: Array.isArray(userId) ? userId : [userId],
    statusId: Array.isArray(statusId) ? statusId : [statusId],
  };

  // Only include onlyActive if it's true
  if (onlyActive) {
    params.onlyActive = true;
  }

  apiClient
    .get('/get-hours-report', { params })
    .then((response) => {
      if (response.data.success) {
        this.reports = response.data.data.data.map(report => ({
          ...report,
          show_tasks: false
        }));
        this.users = response.data.data.users;
        this.statuses = response.data.data.project_statuses;
        this.reports.forEach(report => {
          report.tasks.forEach(task => {
            task.show = false;
          });
        });
      }
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
},
    exportWithoutTasks() {
      this.exportData(false);
    },
    exportWithTasks() {
      this.exportData(true);
    },
    exportData(withTasks) {
      const { dateFrom, dateTo, userId, statusId } = this.filters;
      apiClient
        .get('/get-hours-report', {
          params: {
            date_from: dateFrom,
            date_to: dateTo,
            userId: Array.isArray(userId) ? userId : [userId],
            statusId: Array.isArray(statusId) ? statusId : [statusId],
            export: 1,
            export_with_tasks: withTasks ? 1 : undefined,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `hours-export${withTasks ? '-with-tasks' : ''}.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error('Error exporting data:', error);
        });
    },
    toggleTasks(reportId) {
      const report = this.reports.find((r) => r.project_id === reportId);
      report.show_tasks = !report.show_tasks;
    },
    getUserProjectHours(userHours, userId) {
      const user = userHours.find((u) => u.userId === userId);
      return user ? user.project_worked_hours_formatted : '0';
    },
    getUserTaskHours(userHours, userId) {
      const user = userHours.find((u) => u.userId === userId);
      return user ? user.task_worked_hours_formatted : '0';
    },
    getAuthToken() {
      // Implement your method to get the auth token
      return localStorage.getItem('api_token');
    },
  },
  mounted() {
    this.fetchData();
    document.addEventListener('click', this.closeActionsDropdown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeActionsDropdown);
  },
};
</script>

<style scoped>
/* Add any scoped styles here */



.select2-selection__choice{
  background-color: #6C757D;
}
</style>
